import * as React from 'react';
import { Route, RouterProps } from 'react-router-dom';
import { Environment } from '../types';
import AppConfigContainer from './AppConfigContainer';
import styles from './styles/appStyles';
import VersionCheckContainer from './VersionCheckContainer';
import AppComponent from './App';
import { runwayColors } from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { useIsMobile } from '../mediaQueriesHelpers';
import MetaTags from 'react-meta-tags';
import { RegisterDeviceMobileAlert } from './RegisterDeviceAlert';
import routes from '@/routes';

const DevEnvironmentBanner = () => {
    return (
        <div
            style={{
                backgroundColor: runwayColors.info,
                padding: 8,
                textAlign: 'center',
            }}
        >
            <Text style={{ fontSize: 13, color: 'white' }}>You are in a development environment.</Text>
        </div>
    );
};

interface MainAppContainerProps extends RouterProps {
    environment: Environment;
}

const MainAppContainer: React.FC<MainAppContainerProps> = (props: MainAppContainerProps) => {
    const { environment } = props;

    const isMobile = useIsMobile();

    return (
        <div style={{ ...styles.appContainer, flexDirection: 'column' }}>
            {isMobile && (
                <MetaTags>
                    <meta
                        name="viewport"
                        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
                    />
                </MetaTags>
            )}
            {environment === Environment.Development && <DevEnvironmentBanner />}
            <AppConfigContainer />
            <VersionCheckContainer />
            <Route path={routes.appBuilds} exact={true} render={() => <RegisterDeviceMobileAlert />} />
            <AppComponent />
        </div>
    );
};

export default MainAppContainer;
